import { useState } from "react";
import { Ellipsis } from "lucide-react";
import { Link } from "react-router-dom";
import useClickOutside from "../../../../CustomHooks/useClickOutside";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import visit from "../../../../assets/icons/visits.svg";

function ComplaintActions({ siteId, siteName, complaintId, operator }) {
  const [open, setOpen] = useState(-1);
  const { dropdownRef } = useClickOutside(() => setOpen(-1));
  const { checkPermission } = UsePermissionsClaim();
  const addVisit = checkPermission("add_visit");

  const handleShow = () => {
    setOpen((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };
  const encodedSiteName = encodeURIComponent(siteName);

  return (
    <div className="table-action-btn" onClick={handleShow} ref={dropdownRef}>
      <Ellipsis />
      {open === 1 && (
        <div className={`actionsWrap--u ${open === 1 ? "grid" : "invisible"}`}>
          {addVisit && (
            <Link
              className="actionLink--u"
              to={`/complaint/add-visit/${complaintId}/${siteId}/${encodedSiteName}/${operator}`}
            >
              <img src={visit} alt="add operator" className="w-6" />
              <span className="actionLinkText--u">Add Visit</span>
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
export default ComplaintActions;
